export default __webpack_public_path__ + "static/media/Mayor.de8b3407.png";